import React from 'react'

import { CodingEditor } from 'common/components'
import { useAppDispatch, useAppSelector } from 'common/hooks'
import { useRestrictCopyPaste } from 'common/hooks/useRestrictCopyPast'
import { Task } from 'data/categories'
import { selectTimerStatus, startTask } from 'features/simulator/index'

type PropsType = {
  task: Task
  setScrollTop: (scroll: number) => void
  setCodeLines: (codeLines: string[]) => void
}

export const TaskEditor = ({ task, setScrollTop, setCodeLines }: PropsType) => {
  const dispatch = useAppDispatch()
  const timerStatus = useAppSelector(selectTimerStatus)

  const onChangeHandler = (lines: string[], code: string) => {
    if (timerStatus !== 'active' && code.length !== 0) {
      dispatch(startTask())
    }

    setCodeLines(lines)
  }

  useRestrictCopyPaste({ window, actions: ['paste'] })

  return (
    <div className="box box--editor">
      <CodingEditor language={task.lang} onChange={onChangeHandler} setScrollTop={setScrollTop} />
    </div>
  )
}
